<script setup lang="ts">
const props = defineProps({
  fileId: null
})
const { getFileReference } = useAgent()

const file = computed(() => getFileReference(props.fileId))
</script>

<template>
  <file-inline
    v-if="isDefined(file)"
    :file
    background
    selectable
    location="agent"
  />
  <template v-else>
    [broken file]
  </template>
</template>
